<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
        </b-field>
      </div>
      <div class="column is-3 is-2-desktop">
        <div class="buttons is-right">
          <b-button
            :loading="sending"
            class="is-primary"
            icon-left="plus"
            @click="onAdd"
          >
            {{ $t('attributes.add') + $t('attributes.companies') }}
          </b-button>
        </div>
      </div>
    </nav>
    <b-table
      :data="companies"
      :loading="loading"
      :mobile-cards="false"
      hoverable
      narrowed
      bordered
      paginated
      pagination-position="both"
      backend-pagination
      backend-sorting
    >
      <b-table-column
        field="code"
        :label="$t('attributes.code')"
        width="75"
        sortable
        v-slot="props"
      >
        <p class="has-text-weight-medium">{{ props.row.id }}</p>
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        v-slot="props"
      >
        <p class="has-text-weight-medium">{{ props.row.name }}</p>
      </b-table-column>
      <b-table-column
        field="status"
        :label="$t('attributes.status')"
        sortable
        centered
        v-slot="props"
      >
        <b-tag
          :type="props.row.status ? 'is-info' : 'is-danger'"
          size="is-medium"
        >
          {{ props.row.status ? '顯示' : '隱藏' }}
        </b-tag>
      </b-table-column>
      <b-table-column
        field="tel"
        :label="$t('attributes.tel')"
        sortable
        v-slot="props"
      >
        <p class="has-text-weight-medium">{{ props.row.tel }}</p>
      </b-table-column>
      <b-table-column
        field="email"
        :label="$t('attributes.email')"
        sortable
        v-slot="props"
      >
        <p class="has-text-weight-medium">{{ props.row.email }}</p>
      </b-table-column>
      <b-table-column
        field="address"
        :label="$t('attributes.address')"
        sortable
        v-slot="props"
      >
        <p class="has-text-weight-medium">{{ props.row.address }}</p>
      </b-table-column>
      <b-table-column label="功能" :width="100" centered v-slot="props">
        <b-button type="is-primary" @click.prevent="onModify(props.row)">
          {{ $t('attributes.modify') }}
        </b-button>
      </b-table-column>
    </b-table>
    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <company-form :company="selectedCompany" @send="onSend" />
    </b-modal>
  </section>
</template>

<script>
import { COMPANIES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'
import CompanyForm from '@/components/mis/CompanyForm'

export default {
  name: 'Companies',
  components: { CompanyForm },
  data() {
    return {
      loading: false,
      sending: false,
      searchName: '',
      companies: [],
      selectedCompany: null,
      isEditing: false,
      isFormModalActive: false
    }
  },
  computed: {
    isLoading() {
      return this.loading
    }
  },
  mounted() {
    this.loadCompanies()
  },
  methods: {
    async loadCompanies() {
      try {
        this.searchName = this.searchName ? this.searchName : ' '
        const api = `${COMPANIES_API}/${this.searchName}/search`

        this.loading = true
        const res = await this.axios.get(api)
        this.companies = res.data.data
      } catch (e) {
        this.companies = []

        notifyService.fetch_error('company', e)
      } finally {
        this.loading = false
      }
    },
    onFilter: debounce(function() {
      this.loadCompanies()
    }, 500),
    onAdd() {
      this.selectedCompany = {
        id: null,
        name: '',
        tel: '',
        fax: '',
        sort: 10,
        status: true,
        email: '',
        address: ''
      }
      this.isEditing = false
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedCompany = item
      this.isEditing = true
      this.isFormModalActive = true
    },
    onSend(item) {
      if (this.isEditing) {
        this.onUpdate(item)
      } else {
        this.onCreate(item)
      }
    },
    async onUpdate(item) {
      try {
        const api = `${COMPANIES_API}/${item.id}`

        this.sending = true
        await this.axios.put(api, item)

        await this.loadCompanies()
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async onCreate(item) {
      try {
        const api = `${COMPANIES_API}/${item.id}`

        this.sending = true
        await this.axios.post(api, item)

        await this.loadCompanies()
        notifyService.success(this.$t('attributes.add_succeed'))
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
